<script setup lang="ts">
import { watch } from 'vue';
import { useRoute } from 'vue-router';

import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import { useDevice } from '@modules/core/composables/device';
import TheMerchantSelector from '@modules/merchant/components/TheMerchantSelector/TheMerchantSelector.vue';
import VSidebarMenu from '@modules/sidebar/components/VSidebarMenu/VSidebarMenu.vue';
import { useSidebarStore } from '@modules/sidebar/store';

const route = useRoute();
const store = useSidebarStore();
const { isDesktop } = useDevice();

watch(() => route.path, () => {
  store.toggleValue(false);
});
</script>

<template>
  <div v-data-qa-auto-id="'VSidebarWrapper'" class="flex flex-col">
    <VSidebarMenu v-if="isDesktop" />
    <PSidebar
      v-else
      v-model:visible="store.isVisible"
      :pt="{
        root: 'border-none',
        header: 'p-0',
        content: 'p-0',
      }"
      :show-close-icon="false"
      block-scroll
    >
      <template #header>
        <div class="flex h-[60px] w-full items-center justify-between bg-header-color px-4">
          <VIconButton
            icon="pi-times"
            text-color="white"
            @click="store.isVisible = false"
          />
          <TheMerchantSelector />
        </div>
      </template>
      <VSidebarMenu />
    </PSidebar>
  </div>
</template>
